import React from 'react';
import { Typography } from 'fronton-react';
import { getPopupPhotoUrl, PreparedCategoryData } from 'utils';
import { PhoneLink } from 'common/components';

import {
	AlignTextStyles,
	DescriptionTextStyle,
	ModalContentWrapper,
	ModalInfo,
	ModalPhoto,
	PhoneStyles,
} from './styles';

type CategoryModalProps = {
	categoryData: PreparedCategoryData;
};

export const PopularCategoryModal = ({ categoryData }: CategoryModalProps) => {
	const { name, description, fullPhotoUrl } = categoryData;
	const categoryPhotoUrl = getPopupPhotoUrl(fullPhotoUrl);

	return (
		<ModalContentWrapper>
			<ModalPhoto src={categoryPhotoUrl} alt="category-photo" />
			<ModalInfo>
				<div>
					<Typography className={AlignTextStyles} variant="h2">
						{name}
					</Typography>
					<Typography variant="m" size="body_long" className={DescriptionTextStyle}>
						{description}
					</Typography>
				</div>
				<div className="category-popup__phone">
					<Typography variant="m" size="body_long">
						Для заказа услуги звоните по телефону:
					</Typography>
					<PhoneLink className={PhoneStyles} element="a" />
					<Typography
						className={AlignTextStyles}
						variant="s"
						size="body_short"
						color="text-minor"
					>
						Круглосуточно без выходных. Звонок&nbsp;бесплатный.
					</Typography>
				</div>
			</ModalInfo>
		</ModalContentWrapper>
	);
};
